import { PromiseQueue } from './PromiseQueue';

export let InteractionQueue: PromiseQueue = new PromiseQueue();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/InteractionQueue.ts